import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: baseline;
  width: 100%;
  row-gap: 10px;
  column-gap: 5px;
  flex-wrap: wrap;
`;

export const DocumentContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: baseline;
  width: 100%;
  row-gap: 10px;
  column-gap: 5px;
  flex-wrap: wrap;
`;

export const LoadingContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  height: calc(100vh - 140px);
`;

export const Loader = styled.i`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;

  i {
    font-size: 50px;
  }
`;

export const HorizontalSplit = styled.div`
  border-bottom: 1px solid #ebebeb;
  width: 100%;
`;

export const NoResultsContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: calc(100vh - 215px);
`;

export const FileInputGroup = styled.div`
  display: flex;
  align-items: stretch;
  width: 60%;
  max-width: 900px;
  border: 1px solid #ced4da;
  border-radius: 50px;
  overflow: hidden;
  background: #fff;
`;

export const FileInput = styled.input`
  flex: 1;
  border: none;
  padding: 0;
  font-size: 14px;
  cursor: pointer !important;

  &::-webkit-file-upload-button,
  &::file-selector-button {
    height: 40px;
    padding: 0 16px;
    margin: 0;
    border: none;
    border-right: 1px solid #ced4da;
    background: #6c757d;
    color: #ffffff;
    font-weight: 600;
    cursor: pointer;
  }

  height: 40px;
  line-height: 40px;
  border-radius: 0;
`;

export const SendButton = styled.button`
  height: 40px;
  padding: 0 16px;
  background: #1a1a2e;
  color: #ffffff;
  border: none;
  border-left: 1px solid #ced4da;
  cursor: pointer;
  font-weight: 600;
  transition: filter .2s ease;

  &:hover { filter: brightness(1.05); }

  &:disabled {
    cursor: not-allowed;
    opacity: .6;
  }
`;

export const DeleteButton = styled.button`
  border: 1px solid #6c757d;
  color: #6c757d;
  background: #ffffff;
  font-weight: 500;
  border-radius: 6px;
  padding: 8px 12px;
  transition: all 0.2s ease;
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 0.5rem;
  font-size: 14px;

  &:hover {
    background: #6c757d;
    color: #ffffff;
    border-color: #6c757d;
  }

  &:disabled {
    cursor: not-allowed;
    opacity: .6;
  }
`;
